import React, { useState, useEffect, useContext } from "react";
import { Paper } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../Style/Transfers.scss'
import axios from "axios";
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { errorAlert, handleSuccess } from '../../Components/Alerts';
import MenuItem from '@mui/material/MenuItem';
import { FaTimes } from "react-icons/fa";
import InsertOwner from "../Owners/InsertOwners";
import Autocomplete from "@mui/material/Autocomplete";
import { getUnitID } from "../../Auth/GetUnitCompany";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CircularProgress from '@mui/material/CircularProgress';

function AddCapitalDeposit(props) {
    const headers = authHeader();
    const email = LoginUserDetailed();

    const [date, setDate] = useState("");
    const [invoiceNR, setInvoiceNR] = useState("");
    const [ownerID, setOwnerID] = useState("");
    const [ledgerID, setLedgerID] = useState("");
    const [total, setTotal] = useState("");
    const [coment, setComent] = useState("");
    const [paymentOptions, setPaymentOptions] = useState("");
    const [unId, setUnID] = useState('')

    const [accounts, setAccounts] = useState([]);
    const [owners, setOwners] = useState([]);

    const [ledgers, setLedgers] = useState([]);

    const { fiscalYear } = useContext(FiscalYearContext);
    const [insertingTransaction, setInsertingTransaction] = useState(false);


    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const handleSubmit = (event) => {
        event.preventDefault();
        setInsertingTransaction(true);
        if (!date) {
            errorAlert("Ju lutem plotesoni daten");
            setInsertingTransaction(false);
            return;
        }
        if (!ledgerID) {
            errorAlert("Ju lutem zgjedhni llogarin kontabël");
            setInsertingTransaction(false);
            return;
        }
        if (!paymentOptions) {
            errorAlert("Përzgjedh llogarinë Debitore");
            setInsertingTransaction(false);
            return;
        }
        if (!coment) {
            errorAlert("ju lutem plotesoni komentin");
            setInsertingTransaction(false);
            return;
        }
        if (!total) {
            errorAlert("Ju lutem plotësoni vlerën");
            setInsertingTransaction(false);
            return;
        }
        if (!ownerID) {
            errorAlert("Zgjedheni pronarin");
            setInsertingTransaction(false);
            return;
        }
        const stateDate = {
            Date: date,
            ActionType: "CAD",
            InvoiceNr: invoiceNR,
            // AccountID: accountID,
            Total: total,
            SupplierID: ownerID,
            LedgerID: ledgerID,
            PaymentOptions: paymentOptions,
            CompanyUnitID: unId > 0 ? unId : null,
            Coment: coment,
            CreatedByUser: email,
        };
        axios.post(ApiLink.API_URL + 'CapitalDeposite', stateDate, { headers })
            .then(() => {
                handleSuccess("Deponimi i kapitalit u shtua me sukses");
                setDate("");
                fetchNextInvoiceNumber();
                setLedgerID("");
                setOwnerID("");
                setComent("");
                setPaymentOptions("");
                setTotal("");
                // setAccountName("");
                // setOwnerName("");
                setfield(null);
                setPayField(null);
                setInsertingTransaction(false);
            })
            .catch((error) => {
                setInsertingTransaction(false);
                // console.error(error);
                if (error.response && error.response.status === 409) {
                    setInsertingTransaction(false);
                    errorAlert(error.response.data);
                } else {
                    setInsertingTransaction(false);
                    // errorAlert("An unknown error occurred while processing the request.");
                }
            });
    }

    const fetchAccounts = async (ledgerID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: ledgerID } });
            setAccounts(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchLedger = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Ledger/Get_101_102_Ledgers', { headers });
            setLedgers(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchOwner = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 501 } });
            setOwners(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };
    const fetchNextInvoiceNumber = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CapitalDeposite/InvoiceNr', { headers, params: { fiscalYear: fiscalYear } });
            setInvoiceNR(response.data.NextInvoiceNr);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    //Pjesa per select input field accounts
    const [field, setfield] = useState(null);
    const handleAutocompleteChangeAccounts = (event, value) => {
        if (value && value.AccountID) {
            setOwnerID(value.AccountID);
            setfield(value); // Përditëso `selectedArticle` me vlerën e zgjedhur


        } else {
            // Në rast se vlera është pastruar
            setOwnerID(""); // Vendos vlerën e ArticleID në null
            setfield(null);  // Pastro `Autocomplete`

        }
    };

    const defaultPropsAccounts = {
        options: owners,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>

                </li>
            </>
        ),
    };
    //////

    //Pjesa per select input field payment accounts
    const [payField, setPayField] = useState(null)
    const handleAutocompleteChangePayAccount = (event, value) => {
        if (value && value.AccountID) {
            setPaymentOptions(value.AccountID);
            setPayField(value);
        } else {
            // Në rast se vlera është pastruar
            setPaymentOptions(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsPayAccount = {
        options: accounts,
        getOptionLabel: (option) =>
            option.AccountName || "",
    };

    useEffect(() => {
        getUnitID(headers).then(setUnID);
    }, [headers])

    useEffect(() => {
        fetchOwner();
        fetchLedger();
        fetchNextInvoiceNumber();
        // fetchPaymentType();
        // fetchExpence()
    }, [])

    return (
        <div className="Transfers__Container" style={{ paddingTop: "50px" }}>
            <TitleElements
                icon={MdManageAccounts}
                title="Deponim i kapitalit"
            />
            {/* <div className="header_paragraph">
                <p>Ju lutemi vini re se të gjitha të dhënat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!</p>
            </div> */}
            <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

            <hr></hr>
            <div className="Transfers__Container__AllButtons">
                <div style={{ display: "flex", }}>
                    <InsertOwner fetchData={fetchOwner} type="insert" />
                </div>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "5px" }}>
                        {/* <Link to="#"
                            style={{ width: "110px", textDecoration: "none", color: "green" }}
                        >
                            <button className="button-15"
                                onClick={handleSubmit}
                            >
                                Ruaj & Ri
                            </button>
                        </Link> */}
                        {insertingTransaction ? (
                            <button
                                className="button-15"
                                style={{ background: "#284945" }}
                            >
                                <CircularProgress style={{ color: "white", width: "20px", height: "20px" }} />
                            </button>
                        ) : (
                            <LinkAndClickButton
                                text="Ruaj & Ri"
                                link="#"
                                onClick={handleSubmit}
                            />
                        )}
                        {/* <LinkAndClickButton
                            text="Ruaj & Ri"
                            link="#"
                            onClick={handleSubmit}
                        /> */}
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        {/* <Link
                            to="/money/withdrawal"
                            style={{ width: "110px", textDecoration: "none" }}
                        >
                            <button className="button-15" variant="contained">
                                <FaTimes /> Mbyll
                            </button>
                        </Link> */}
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/money/capitalDeposit"
                        />
                    </div>
                </div>
            </div>
            {/* <div className='header_paper2'></div> */}
            <HeaderPaperComponent />
            <form className='Transfers__Container__Format'>
                <Paper>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div className='Forma1'>
                            <div className='Boxx'>
                                <TextField
                                    className="Transfers__Container__Format__SameInput"
                                    id="invoiceNR"
                                    label="Numri Deponimit"
                                    variant="outlined"
                                    type="text"
                                    name='InvoiceNr'
                                    value={"CAD-" + fiscalYear + "-" + invoiceNR}
                                    onChange={event => { setInvoiceNR(event.target.value) }}
                                    disabled

                                />
                                <TextField
                                    required
                                    className="Transfers__Container__Format__SameInput"
                                    id="date"
                                    type="date"
                                    variant="outlined"
                                    name='Date'
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    inputProps={{
                                        min: minDate, // Kufizimi minimal i datës
                                        max: maxDate, // Kufizimi maksimal i datës
                                    }}
                                />
                                <hr style={{ marginLeft: "15px" }}></hr>
                                <div className="Debit__Credit__Form">
                                    <TextField
                                        required
                                        autoComplete="off"
                                        className="Transfers__Container__Format__SameInput"
                                        id="LedgerID"
                                        select
                                        label="Përzgjedh llogarinë kontabel Debitore"
                                        defaultValue=""
                                        value={ledgerID}
                                        onChange={event => { setLedgerID(event.target.value); fetchAccounts(event.target.value) }}
                                    >
                                        {ledgers.map((data) => (
                                            <MenuItem key={data.LedgerID} value={data.LedgerID}>{data.LedgerNameEN}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Autocomplete
                                        fullWidth
                                        {...defaultPropsPayAccount}
                                        id="include-input-in-list"
                                        includeInputInList
                                        onChange={handleAutocompleteChangePayAccount}
                                        value={payField}
                                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "90%", marginLeft: "5%" }}
                                                {...params}
                                                label="Përzgjedh llogarinë Debitore"
                                            // variant="filled"
                                            //   onKeyPress={handleKeyPress}
                                            />
                                        )}
                                    />
                                </div>
                                {/* <div className="Debit__Credit__Form">
                                    <TextField
                                        className="Transfers__Container__Format__SameInput"
                                        id="outlined-basic"
                                        label="Përzgjedh llogarinë kontabel Debitore"
                                        variant="outlined"
                                        name='Total'
                                        value="501-Kapitali pronarit"
                                        disabled
                                    />
                                    <Autocomplete
                                        fullWidth
                                        {...defaultPropsAccounts}
                                        // sx={{ m: 2 }}
                                        id="include-input-in-list"
                                        includeInputInList
                                        value={field}  // Lidheni me state-in `selectedArticle`
                                        onChange={handleAutocompleteChangeAccounts}
                                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "90%", marginLeft: "5%" }}
                                                {...params}
                                                label="Përzgjedh Pronarin"
                                            // variant="filled"
                                            //   onKeyPress={handleKeyPress}
                                            />
                                        )}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                            },
                                        }}
                                    />
                                </div> */}
                            </div>
                            <div className='Boxx'>
                                <TextField
                                    className="Transfers__Container__Format__SameInput"
                                    required
                                    autoComplete="off"
                                    id="outlined-basic"
                                    label="Komenti"
                                    variant="outlined"
                                    name='Comment'
                                    value={coment}
                                    onChange={event => setComent(event.target.value)}
                                />
                                <TextField
                                    required
                                    autoComplete="off"
                                    className="Transfers__Container__Format__SameInput"
                                    id="outlined-basic"
                                    label="Vlera"
                                    variant="outlined"
                                    name='Total'
                                    value={total}
                                    onChange={event => setTotal(event.target.value)}
                                />
                                <hr style={{ marginRight: "65px" }}></hr>
                                <div className="Debit__Credit__Form">
                                    <TextField
                                        className="Transfers__Container__Format__SameInput"
                                        id="outlined-basic"
                                        label="Përzgjedh llogarinë kontabel Kreditore"
                                        variant="outlined"
                                        name='Total'
                                        value="501-Kapitali pronarit"
                                        disabled
                                    />
                                    <Autocomplete
                                        fullWidth
                                        {...defaultPropsAccounts}
                                        // sx={{ m: 2 }}
                                        id="include-input-in-list"
                                        includeInputInList
                                        value={field}  // Lidheni me state-in `selectedArticle`
                                        onChange={handleAutocompleteChangeAccounts}
                                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "90%", marginLeft: "5%" }}
                                                {...params}
                                                label="Përzgjedh Pronarin"
                                            // variant="filled"
                                            //   onKeyPress={handleKeyPress}
                                            />
                                        )}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                            },
                                        }}
                                    />
                                </div>
                                {/* <div className="Debit__Credit__Form">
                                    <TextField
                                        required
                                        autoComplete="off"
                                        className="Transfers__Container__Format__SameInput"
                                        id="LedgerID"
                                        select
                                        label="Përzgjedh llogarinë kontabel Kreditore"
                                        defaultValue=""
                                        value={ledgerID}
                                        onChange={event => { setLedgerID(event.target.value); fetchAccounts(event.target.value) }}
                                    >
                                        {ledgers.map((data) => (
                                            <MenuItem key={data.LedgerID} value={data.LedgerID}>{data.LedgerNameEN}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Autocomplete
                                        fullWidth
                                        {...defaultPropsPayAccount}
                                        id="include-input-in-list"
                                        includeInputInList
                                        onChange={handleAutocompleteChangePayAccount}
                                        value={payField}
                                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "90%", marginLeft: "5%" }}
                                                {...params}
                                                label="Përzgjedh llogarinë Kreditore"
                                            // variant="filled"
                                            //   onKeyPress={handleKeyPress}
                                            />
                                        )}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </Box>
                </Paper>
            </form>
            <div></div>
        </div >
    );
}

export default AddCapitalDeposit;